import { render } from "./AppTableLayout.vue?vue&type=template&id=4272d394&ts=true"
import script from "./AppTableLayout.vue?vue&type=script&lang=ts"
export * from "./AppTableLayout.vue?vue&type=script&lang=ts"

import "./AppTableLayout.vue?vue&type=style&index=0&id=4272d394&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__